import React from 'react';

import categoryLabels from '../../../../config/banking-category-labels';

export default function SubCategory({ subCategoryList }) {
  const [currentCategory, ...subCategories] = subCategoryList;

  const currentCategoryLabel = categoryLabels[currentCategory];
  if (!currentCategoryLabel) {
    console.error(`Unknown subcategory: ${currentCategory}`);
    return null;
  }

  const hasSubCategories = subCategories.length > 0;

  return (
    <div className="d-inline">
      {currentCategoryLabel}
      {hasSubCategories && (
        <div className="ml-2">
          <span>{'→ '}</span>
          <SubCategory subCategoryList={subCategories} />
        </div>
      )}
    </div>
  );
}
